import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams, createSearchParams, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'
import Header from "./layouts/Header";
import Loading from "./Loading";
import { getViewInstance } from "../actions/viewinstance";
import ProgressBar from "./partials/hra/ProgressBar";
import { Button, Container, ButtonGroup, IconButton, Paper, Grid, Skeleton } from "@mui/material";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { LoadingButton } from "@mui/lab"
import HRAContainer from "./partials/hra/HRAContainer";
import { questionsetHydrate, selectQuestionSets } from "../reducers/survey_questionset";
import { sectionHydrate } from "../reducers/survey_section";
import { questionHydrate, selectQuestions } from "../reducers/survey_question";
import { surveyHydrate } from "../reducers/survey";
import Footer from "./layouts/Footer";
import { Box } from "@mui/system";
import { viewinstanceClear } from "../reducers/reuseable_vi";

const HRA2 = (props) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const { user: currentUser } = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const [callVI, setCallVI] = useState(false)
    const { viewInstance, settings } = useSelector(state => state.viewinstance)
    const [searchParams, setSearchParams] = useSearchParams();

    const surveyStatus = useSelector(state => state.surveys.status)
    const sectionStatus = useSelector(state => state.sections.status)
    const questionsetStatus = useSelector(state => state.questionsets.status)
    const questionStatus = useSelector(state => state.questions.status)

    const errorQSs = useSelector((state) => selectQuestionSets(state).filter(item => item.ValueLimitationError && !item.ValueLimitationPassed))

    const Questions = useSelector((state) => selectQuestions(state)).sort((a, b) => a.QuestionSetSequence - b.QuestionSetSequence || a.QuestionSequence - b.QuestionSequence)

    const [hasErrors, setHasErrors] = useState(false)
    const [isCompleting, setIsCompleting] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [quizState, setQuizState] = useState({
        Questions: [],
        Username: '',
        AuthToken: '',
        ParticipantGuid: '',
        ResponseGuid: '',
        QuizsDirection: 'left',
        QuestionsAnswered: 0,
        QuestionTotal: 1,
        UnitOfMeasure: 'IMPERIAL',
        LoadingError: false,
        ErrorViewInstance: [],
        isTimedOut: false,
        CurrentIndex: 0,
        StartingAssessment: false
    })

    const [unansweredQuestions, setUnansweredQuestions] = useState({
        Questions: [],
        Index: 0
    })

    useEffect(() => {

        if (surveyStatus === 'idle' && quizState && quizState.Questions && quizState.Questions.SurveyData) {
            const surveyData = quizState.Questions.SurveyData
            // right now survey data only has 1 questionset
            const Sections = {}
            const QuestionSets = {}
            const Questions = {}
            for (var s = 0; s < surveyData.length; s++) {
                // split 'Sections' out of the current object. 
                const { QuestionSetQuestionSet, ...SectionObject } = surveyData[s]
                // no parent id to add
                Sections[SectionObject.QuestionSetId] = SectionObject

                for (var qs = 0; qs < QuestionSetQuestionSet.length; qs++) {
                    // split questionsetquestions out of the current object. 
                    const { QuestionSetQuestions, ...QuestionSetObject } = QuestionSetQuestionSet[qs]
                    // add parent id
                    QuestionSets[QuestionSetObject.QuestionSetId] = { ...QuestionSetObject, SectionId: SectionObject.QuestionSetId, WasChanged: false }

                    for (var q = 0; q < QuestionSetQuestions.length; q++) {
                        const QuestionObject = { ...QuestionSetQuestions[q], QuestionSetId: QuestionSetObject.QuestionSetId, QuestionSetSequence: QuestionSetObject.QuestionSetSequence, QuestionSetName: QuestionSetObject.QuestionSetName }
                        // add parent id
                        Questions[QuestionObject.QuestionId] = QuestionObject
                    }
                }
            }

            setIsLoading(true)

            dispatch(sectionHydrate(Sections))
            dispatch(questionsetHydrate(QuestionSets))
            dispatch(questionHydrate(Questions))
            dispatch(surveyHydrate())
            dispatch(viewinstanceClear({ ViewInstanceId: "HomePage" }))

        }
    }, [surveyStatus, quizState, dispatch])

    useEffect(() => {
        if (surveyStatus == "success" && Questions.length && isLoading) {
            setIsLoading(false)
            scrollToFirstUnanswered()
        }
    }, [surveyStatus, Questions])

    useEffect(() => {
        if (!callVI && (!viewInstance || !viewInstance.SurveyPage) && currentUser && currentUser.AuthToken) {
            setCallVI(true);
            let vi = searchParams.get('vi')
            dispatch(getViewInstance('B87190C3-B9C8-41D7-A1C8-10E07FBA0D3E', currentUser.AuthToken))
        }
    }, [location.pathname])

    useEffect(() => {
        //IF EMPTY VI OR NOT THE DESIRED VI AND THE VI HAS NOT BEEN CALLED YET
        if ((!quizState.Questions.length && !quizState.StartingAssessment && settings && viewInstance && viewInstance.SurveyPage)) {
            setQuizState({ ...quizState, StartingAssessment: true })
            getAssmtGuid()
        }
        //WINDOW.LOCATION PROVIDES EXTRA CONTEXT SO WHEN TEH URL UPDATES THE APP UPDATES
    }, [viewInstance, settings])

    const getAssmtGuid = () => {
        let responseGuid = ''
        let asmtprodguid = viewInstance.SurveyPage.AssessmentProductGuid
        const productGuid = settings.PersonSettingValues['ASSMT PRODUCT GUID'] ? settings.PersonSettingValues['ASSMT PRODUCT GUID'] : settings.OrganizationSettingValues['ASSMT PRODUCT GUID']

        // commented out the participant setting code, it was causing issues with multi HRA modes
        // this should be reused when we use querystring params (product+response/assmtguid)

        // fetch('../../WsWebServicePlatform/Participant/Setting/Set/' + currentUser.AuthToken + '/' + settings.SessionVariableValues["PERSON GUID"] + '/ASSMT%20PRODUCT%20GUID/' 
        // + ( productGuid) + '/', {
        //     method: "POST",
        //     headers: {
        //         'Accept': 'application/json',
        //         'Content-Type': 'application/json'
        //     },
        //     body: {
        //     }
        // })
        //     .then(response => response.json())
        //     .then(response => {
        //         if (response.Success) {
        fetch('../../WsWebServicePlatform/Participant/SessionVar/Get/' + currentUser.AuthToken + '/RESPONSE%20GUID' + '/')
            .then(response => response.json())
            .then(response => {
                if (!response.Info.length) {
                    fetch('../../WsWebServicePlatform/Participant/Setting/Get/' + currentUser.AuthToken + '/' + settings.SessionVariableValues['PERSON GUID'] + '/ASSMT%20PRODUCT%20GUID' + '/')
                        .then(response => response.json())
                        .then(
                            response => {
                                let asmtguid = (response && response.Info.length > 0) ? response.Info[0].SettingText : productGuid
                                fetch('../../WsWebServiceHra/StartAssessment/' + currentUser.AuthToken + '/' + asmtguid + '/',
                                    {
                                        method: 'POST',
                                        headers: {
                                            'Accept': 'application/json',
                                            'Content-Type': 'application/json'
                                        },
                                        body: {

                                        }
                                    })
                                    .then(response => response.json())
                                    .then(response => {
                                        getQuestions(response.Info[0].AssmtGuid)
                                        setQuizState({
                                            ...quizState,
                                            ResponseGuid: response.Info[0].AssmtGuid,
                                            StartingAssessment: false
                                        })
                                        storeAssmtGuidToSession(response.Info[0].AssmtGuid)
                                        //setSearchParams('assmtGuid', response.Info[0].AssmtGuid)
                                    })
                            }
                        )
                        

                }

                else {
                    responseGuid = response.Info[0].Value
                    getQuestions(responseGuid)
                    setQuizState({
                        ...quizState,
                        ResponseGuid: responseGuid,
                        StartingAssessment: false
                    })
                    //storeAssmtGuidToSession(response.Info[0].Value)
                    //setSearchParams('assmtGuid', response.Info[0].Value)
                    //this is for test login and othe rpages that send assmtGuid through session
                }

            })
        //     }
        console.log("Fetch assmtGuid end Response ", responseGuid)

        //  })
    }

    useEffect(() => {
    }, quizState.ResponseGuid)


    const scrollToFirstUnanswered = () => {
        let limitationCounter = 0



        let lastAnswered = settings.ResponseSettingValues["LAST QUESTION ANSWERED"]
        let lastAnsweredIndex = -1
        let element = null
        for (let i = 0; i < Questions.length; i++) {
            if (lastAnswered = Questions[i].QuestionId) lastAnsweredIndex = Questions[i].QuestionSetId;

            if (Questions[i].QuestionSetName.indexOf("RACE") > 0) {
                if (Questions[i].Responses[0].Response.length) {
                    limitationCounter++
                }
                if (Questions[i + 1] && !Questions[i + 1].QuestionSetName.indexOf("RACE") && limitationCounter === 0) {
                    //if the next question is no longer RACE, if none are answered scroll to
                    element = document.getElementById("QS_" + Questions[i].QuestionSetId)

                }
            } else {
                if (!Questions[i].Responses[0].Response.length && Questions[i].QuestionDisplayedFlag === "1" && Questions[i].QuestionRequiredFlag === "1") {
                    element = document.getElementById("QS_" + Questions[i].QuestionSetId)

                }
            }

            if ((lastAnswered > 0 && lastAnsweredIndex >= 0 && element) || (lastAnswered <= 0 && element)) break;
        }

        if (lastAnsweredIndex && element && document.getElementById("QS_" + lastAnsweredIndex) && document.getElementById("QS_" + lastAnsweredIndex).offsetTop < element.offsetTop) {

            document.getElementById("QS_" + lastAnsweredIndex).scrollIntoView({
                block: "center",
                behavior: "smooth"
            })

        } else {
            if (element) {
                element.scrollIntoView({
                    block: "center",
                    behavior: "smooth"
                })
            }
        }
    }
    const storeAssmtGuidToSession = (assmtGuid) => {
        if (searchParams.get("asAuthToken")) {
            fetch("../../WsWebServicePlatform/Participant/SessionVar/Set/" + searchParams.get('asAuthToken') + '/RESPONSE%20GUID/' + assmtGuid + '/', {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: {
                }
            })
        } else {
            fetch("../../WsWebServicePlatform/Participant/SessionVar/Set/" + currentUser.AuthToken + '/RESPONSE%20GUID/' + assmtGuid + '/', {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: {
                }
            })
        }
    }

    const getQuestions = (responseGuid) => {
        console.log("Fetch for Response ", responseGuid)
        fetch('../../WsWebServiceWellSuite/GetViewInstance/' + currentUser.AuthToken + '/8C292A8F-C14E-470B-A164-015F1CB2E2DD/',
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'

                }
            })
            .then(response => response.json())
            .then(response => {
                setQuizState({
                    ...quizState,
                    Questions: response.Info[0].ViewInstanceData[0].SurveyPage,
                    StartFromBeginning: true,
                    ResponseGuid: responseGuid,
                    UnitOfMeasure: response.Info[0].ViewInstanceData[1].SessionVariableValues["UNIT OF MEASURE"]
                })
            })
    }

    /*setClientColor(clientColor){
        theme = createMuiTheme({
        palette: {
            primary: {
                main: clientColor
            }
        }
    })} */

    const checkForErrors = () => {
        if (errorQSs.length) {
            document.getElementById('QS_' + errorQSs[0].QuestionSetId).scrollIntoView({
                block: "center",
                behavior: "smooth"
            })
        } else {
            completeAssessment()
        }
    }

    const completeAssessment = () => {
        setIsCompleting(true)

        fetch('../../WsWebServiceHra/CompleteAssessment/' + currentUser.AuthToken + '/' + quizState.ResponseGuid + '/',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: {

                }
            })
            .then(response => response.json())
            .then(response => {
                if (response.Success) {

                    //this.props.completeSuccessful(true)

                    completeSuccessful(true)
                } else {


                    setIsCompleting(false)
                    if (response.Status[0].ErrorID === -3) {
                        setHasErrors(true)
                        setUnansweredQuestions({
                            ...unansweredQuestions,
                            Questions: response.Status
                        })
                        document.getElementById("Q_" + response.Status[0].ErrorMessage).scrollIntoView({
                            block: 'center',
                            behavior: 'smooth'
                        })
                    }
                    /*if(response.Info.length){
                        
                     }*/
                }
            })
    }

    const completeSuccessful = (didCompleteSuccessfully) => {
        if (didCompleteSuccessfully) {
            navigate({ pathname: '/personalreport', search: createSearchParams({ vi: '8AC17D1E-2871-44D9-ACC0-867285149337', assmtguid: currentUser.AuthToken }).toString() })

        }
    }

    const scrollToUnanswered = (direction) => {
        if (direction === 'up') {
            if (unansweredQuestions.Index != 0) {
                document.getElementById("Q_" + unansweredQuestions.Questions[unansweredQuestions.Index - 1].ErrorMessage).scrollIntoView({
                    block: 'center',
                    behavior: 'smooth'
                })
                setUnansweredQuestions({ ...unansweredQuestions, Index: unansweredQuestions.Index - 1 })
            }
        }
        if (direction === 'down') {
            if (unansweredQuestions.Index != unansweredQuestions.Questions.length - 1) {
                document.getElementById("Q_" + unansweredQuestions.Questions[unansweredQuestions.Index + 1].ErrorMessage).scrollIntoView({
                    block: 'center',
                    behavior: 'smooth'
                })
                setUnansweredQuestions({ ...unansweredQuestions, Index: unansweredQuestions.Index + 1 })
            }
        }
    }

    if (surveyStatus === 'success') {
        let progressBar
        let status = 'active'
        return (
            <div>
                <Header />
                <div style={{ marginTop: '150px' }}>
                    <ProgressBar />

                    <HRAContainer questions={quizState.Questions} responseGuid={quizState.ResponseGuid} />

                    <Container maxWidth="sm" >
                        {!hasErrors &&
                            <Grid container
                                direction="row"
                                justifyContent="center"
                                alignItems="center">
                                {isCompleting && <LoadingButton loading loadingPosition="end" sx={{ padding: '35px 50px 35px 50px' }}>
                                    {viewInstance?.SurveyPage?.OtherLabels?.CompleteButtonText || "Complete"}
                                </LoadingButton>}
                                {!isCompleting && <Button variant="contained"
                                    size="large"
                                    onClick={() => checkForErrors()}
                                    sx={{ padding: '35px 50px 35px 50px', fontSize: 'larger' }}>{viewInstance?.SurveyPage?.OtherLabels?.CompleteButtonText || "Complete"}</Button>}

                            </Grid>}
                        {hasErrors &&
                            <Container disableGutters maxWidth='100%' sx={{ position: 'fixed', width: '100%', bottom: '0px', left: '0px' }}>
                                <Paper elevation={12}>
                                    <Grid container direction="row" justifyContent="center" alignItems="center" >

                                        <ButtonGroup>
                                            <IconButton onClick={() => scrollToUnanswered('up')}><KeyboardArrowUpIcon /> </IconButton>
                                            {
                                                isCompleting && <LoadingButton loading loadingPosition="end" sx={{ padding: '25px 35px 25px 35px' }}>{viewInstance?.SurveyPage?.OtherLabels?.CompleteButtonText || "Complete"}</LoadingButton>
                                            }
                                            {
                                                !isCompleting && <Button variant="contained" onClick={() => completeAssessment()}>{viewInstance?.SurveyPage?.OtherLabels?.CompleteButtonText || "Complete"}</Button>
                                            }

                                            <IconButton onClick={() => scrollToUnanswered('down')}><KeyboardArrowDownIcon /></IconButton>
                                        </ButtonGroup>
                                    </Grid>
                                </Paper>

                            </Container>}
                    </Container>
                </div>
                <Footer />
            </div>
        )
    } else {
        return (
            <div>
                <Header />
                <Box py={9}>
                    {[0, 1, 2, 3, 4, 5, 6, 7, 8].map(x => {
                        return (
                            <Box py={6} px={4}>
                                <Paper elevation={1}>
                                    <Skeleton variant="rectangular" animation="wave" sx={{ paddingTop: "20%" }} height={0} />
                                </Paper>
                            </Box>
                        )
                    })
                    }
                </Box>
                <Footer />
            </div>
        )
    }
}

export default HRA2